import { Link, useLocation } from 'react-router-dom'

import makeStyles from '@mui/styles/makeStyles'

import Paper from '@mui/material/Paper'

import { plainLinkStyle, userDialogStyles } from '../../commonStyles'

import logo from '../../assets/logo-full.svg'

import { useAppUser, useCurrentHousehold } from '../hooks'

const useStyles = makeStyles(
  theme => ({
    ...userDialogStyles(theme),

    body: {
      ...theme.typography.body1
    },

    link: plainLinkStyle(theme.palette.purple.P600)(theme)
  }),
  {
    name: 'NotFound'
  }
)

const NotFound = props => {
  const appUser = useAppUser()
  const location = useLocation()
  const household = useCurrentHousehold()

  const { id: householdId } = household ?? {}
  const classes = useStyles(props)
  return (
    <div className={classes.root}>
      <div className={classes.dialogContainer}>
        <Paper className={classes.dialog}>
          <section className={classes.logo}>
            <img src={logo} alt="Undivided Logo" />
          </section>

          <h2 className={classes.prompt}>Whoops! We can't seem to find this page for you.</h2>

          <section className={classes.body}>
            A few possible reasons:
            <ul>
              <li>This feature is no longer supported</li>

              <li>This specific link is not compatible with your account</li>

              <li>The page isn't accessible within your membership</li>
            </ul>
            {!appUser && (
              <>
                You might also have meant to go somewhere else. Here are some possibilities:
                <ul>
                  <li>
                    <Link className={classes.link} to="/login">
                      Login page
                    </Link>
                  </li>

                  <li>
                    <Link className={classes.link} to="/join/start?referring_page=loginScreen">
                      Sign-up page
                    </Link>
                  </li>

                  <li>
                    <Link className={classes.link} to="/password-reset">
                      Password reset page
                    </Link>
                  </li>
                </ul>
              </>
            )}
            If you think this is an error, please contact{' '}
            <Link
              className={classes.link}
              to={`mailto:support@undivided.io?subject=Report%20Page%20Not%20Found&body=Household%20ID:%20${
                householdId ?? 'Not found'
              }%0DPage%20not%20found:%20${location.pathname}%0D%0DAnything%20to%20add?`}
              target="_blank"
              rel="noopener noreferrer"
            >
              support@undivided.io
            </Link>
            .
          </section>
        </Paper>
      </div>
    </div>
  )
}

export default NotFound
